import React from 'react';

const TeacherDashboard = () => {
  return (
    <div>
      <h1>Teacher Dashboard</h1>
      <p>Welcome, Teacher!</p>
    </div>
  );
};

export default TeacherDashboard;